import React from "react";

export default function ProgressRing({ pct, size = 120, stroke = 10, live = false }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const color = live ? "#2B4C3F" : pct === 100 ? "#2B4C3F" : pct >= 50 ? "#C6A87C" : "#D98324";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E5E3DB" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={c}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-head text-2xl font-extrabold tracking-tight">{pct}%</span>
        <span className="overline text-muted-foreground text-[0.6rem]">{live ? "Live" : "Ready"}</span>
      </div>
    </div>
  );
}
